import { Injectable } from '@angular/core'
import { reactor } from '../reactor'
import { customerOperations } from '../stores/customer-store'
import { CustomerWriterAccess } from '../types'
import { CustomerWriterAccessesService } from '../services/customer-writer-access-service'
import { errorToast, successToast } from '../toaster'
import { donePromise } from '../utils'

interface CustomerWriterAccessUpdates {
  access: CustomerWriterAccess['access'] | 'none';
}

@Injectable({providedIn: 'root'})
export class CustomerWriterAccessActions {
  customerWriterAccessesService: CustomerWriterAccessesService = new CustomerWriterAccessesService();

  updateCustomerWriterAccess(writerId: number, customerId: number, updates: CustomerWriterAccessUpdates): Promise<any> {
    const p = this.customerWriterAccessesService.updateCustomerWriterAccess(writerId, customerId, updates).then(() => {
      reactor.dispatch(customerOperations.updateCustomerWriterAccess, {writerId: writerId, customerId: customerId, updates: updates})
      this.updateToast(updates)
    })
    .catch(() => {
      errorToast('An error occurred while loading writer access information, please reload this page')
    })
    return donePromise(p)
  }

  updateCustomerWriterAccessForAccount(writerId: number, updates: CustomerWriterAccessUpdates): Promise<void> {
    const p = this.customerWriterAccessesService.updateCustomerWriterAccessForAccount(writerId, updates).then(() => {
      reactor.dispatch(customerOperations.updateCustomerWriterAccessForAccount, {writerId: writerId, updates: updates})
      this.updateToast(updates)
    })
    return donePromise(p)
  }

  loadCustomerWriterAccess(writerId: number, customerId: number): Promise<CustomerWriterAccess> {
    const p = this.customerWriterAccessesService.getCustomerWriterAccess(writerId, customerId)
    p.then(customerWriterAccess => {
      if (customerWriterAccess) {
        reactor.dispatch(customerOperations.setCustomerWriterAccess, customerWriterAccess)
      }
    })
    return p
  }

  loadCustomerWriterAccessForAccount(writerId: number): Promise<CustomerWriterAccess> {
    const p = this.customerWriterAccessesService.getCustomerWriterAccessForAccount(writerId)
    p.then(customerWriterAccess => {
      if (customerWriterAccess) {
        reactor.dispatch(customerOperations.setCustomerWriterAccessForAccount, customerWriterAccess)
      }
    })
    return p
  }

  loadAllCustomerWriterAccesses(writerId: number): Promise<CustomerWriterAccess[]> {
    const p = this.customerWriterAccessesService.getAllCustomerWriterAccesses(writerId)
    p.then(customerWriterAccesses => {
      const accountAccess = customerWriterAccesses.find(cwa => cwa.accountId !== null)
      customerWriterAccesses.splice(customerWriterAccesses.indexOf(accountAccess), 1)
      reactor.batch(() => {
        if (accountAccess) reactor.dispatch(customerOperations.setCustomerWriterAccessForAccount, accountAccess)
        if (customerWriterAccesses) reactor.dispatch(customerOperations.setCustomerWriterAccesses, {customerWriterAccesses, writerId})
      })
    })
    return p
  }

  private updateToast(updates: CustomerWriterAccessUpdates): void {
    if (updates.access === 'none') {
      successToast("Preference removed")
    } else {
      successToast(`Writer ${updates.access}`)
    }
  }
}
